import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { StoreVariableService } from '../store-variable.service';
@Component({
  selector: 'app-advance-vehicle-list',
  templateUrl: './advance-vehicle-list.component.html',
  styleUrls: ['./advance-vehicle-list.component.scss']
})
export class AdvanceVehicleListComponent implements OnInit, OnDestroy {

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private ApiService: ApiService, private storeservice: StoreVariableService, private router: Router, private behaviourservice: BehaviourSubjectService, private route: ActivatedRoute) { }
  ngOnDestroy(): void {
    this.storeservice.isclick.next(false)

  }
  sub: Subscription = new Subscription();
  selectedLevel2ID: any;
  selectedLevel3ID: any;
  l2Data: any;
  level2Data: any = [];
  level3data: any[] = [];
  searchDataList: any = [];
  listingData: any = [];
  SearchValue: any;

  userEnteredValue: any = '';
  @Input() searchDataListVehicleMap: any
  @Input() level2DataMap: any

  isBrtLinkVisible: boolean = false;
  breadCrumb: {
    l1_actual_name: string,
    l2_actual_name: string,
    l3_actual_name: string,
    l4_actual_name: string,
    filterCount: number,
  };
  selectedFilters: any = [];
  productPrice: any;
  level3DataImages = []
  erroemsg: any;
  displayModal = false
  productDetailsData: any = [];
  setTrue: boolean = false
  id: string;
  val: string;
  val2: string;
  isMobile: boolean = false;
  changeId: boolean = false
  templevel2data: any;
  level3selected: any;
  level2newImages: any;
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {

        this.isMobile = true;
      } else {

        this.isMobile = false;
      }
      this.route.params.subscribe(params => {
        this.id = params['level1'];
        this.val = params['level2'];
        this.SearchValue = params['search']
        if (this.val2 == undefined) {
          this.storeservice.breadCrumb.l3_actual_name = ''
          this.storeservice.breadCrumb.l4_actual_name = ''
        }
      });
      this.storeservice.breadCrumb.l1_actual_name = this.id
      this.storeservice.breadCrumb.l2_actual_name = this.val
      localStorage.setItem('pageLevel', '1');

      localStorage.setItem('l1SearchData', this.id)
      localStorage.setItem('l2SearchData', this.val)


      // this.searchDataList=this.storeservice.newsearchDataList
      // this.level2Data=this.storeservice.newlevel2Data

      // localStorage.setItem('pageLevel', '2');
      // this.onSearchClick('', this.val, '');

      this.onsearch(this.id, this.val)

      // this.getLevel2Data(this.val)
      this.breadCrumb = this.storeservice?.breadCrumb


      this.storeservice.isclick.subscribe((res) => {
        if (res) {
          this.changeId = res
          this.onclickLevel2(this.storeservice.isclickid, 'level2')
          if (this.templevel2data) {
            this.onSearchClick('', '', this.templevel2data[this.storeservice.isclickid]?.l3_actual_name)
          }
        }
      })

      if (this.level2Data?.length == 1) {
        this.onclickLevel2(0, 'level2')
        this.onSearchClick('', '', this.level2Data[0]?.l3_actual_name)
      }
      // setTimeout(() => {
      //   this.storeservice.breadCrumb?.l3_actual_name=this.level3data[0].ppl_display_name
      // this.breadCrumb=this.storeservice.breadCrumb
      //         }, 500);
      // this.searchDataList=this.searchDataListVehicleMap
      // this.level2Data=this.level2DataMap
    }
  }
  onsearch(level1: any, level2: any) {
    let data = {
      level1: level1,
      level2: level2,
      level3: '',
      search: ''
    };


    this.ApiService.advanceSearch(data).subscribe((res: any) => {
      if (res.success) {
        localStorage.removeItem('l2SearchData');
        localStorage.removeItem('l3SearchData');
        this.searchDataList = res?.data;
        this.level2Data = this.searchDataList?.data

        if (this.level2Data?.length == 1 || this.changeId) {
          this.onclickLevel2(this.storeservice.isclickid, 'level2')
          // this.onSearchClick('', '', level2)
          this.onsearchlevel3(level1, level2)
        }




        // this.getLevel2Data(this.val)
      }
    })
  }

  onsearchlevel3(level1: any, level2: any) {
    this.level3selected = this.level2Data[this.storeservice.isclickid]?.l3_actual_name
    let data = {
      level1: level1,
      level2: level2,
      level3: this.level2Data[this.storeservice.isclickid]?.l3_actual_name,
      search: ''
    };


    this.ApiService.advanceSearch(data).subscribe((res: any) => {
      if (res.success) {
        this.level3data = res?.data?.data
        this.level2newImages = res?.data

      }
    })
  }
  getLevel2Data(value: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.selectedLevel3ID = null;
      localStorage.setItem('pageLevel', '2');
      this.onSearchClick('', value, '');
    }
  }
  onclickLevel2(id, flag) {
    if (flag == 'level2') {
      this.selectedLevel2ID = id;
      this.storeservice.isclickid = id
    }
    else {
      // this.level3data = []
      this.selectedLevel3ID = id;
    }
  }
  clearLocalStorageData() {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('pageLevel') === '1') {
        localStorage.removeItem('l2SearchData');
        localStorage.removeItem('l3SearchData');
      }
      if (localStorage.getItem('pageLevel') === '2') {
        localStorage.removeItem('l3SearchData');
      }
    }
  }
  serach2click(value: any) {
    this.level3selected = value?.l3_actual_name
  }
  level4Click(val) {


    if (isPlatformBrowser(this.platformId)) {
      // this.breadCrumb?.l3_actual_name = val.ppl_actual_name
      this.breadCrumb.l3_actual_name = val.ppl_display_name
      let data = {
        vehicle_number: val.vc_number
      }
      this.ApiService.getVehicleDetails(data).subscribe({
        next: (res: any) => {
          this.erroemsg = res?.data?.msg
          if (res.success) {
            this.level3DataImages = val.ppl_image_path
            this.displayModal = true;
            this.productDetailsData = res?.data

            this.productPrice = this.productDetailsData.price_range
            this.setTrue = true

            this.selectedFilters = this.level3data.filter((item: any) => item.ppl_display_name == this.breadCrumb?.l3_actual_name)

            if (this.productDetailsData) {

              this.storeservice.productDetailsData = this.productDetailsData
              this.storeservice.level3DataImages = this.level3DataImages
              this.storeservice.level3data = this.level3data
              this.storeservice.productPrice = this.productPrice
              this.storeservice.breadCrumb = this.breadCrumb
              // this.router.navigate(['advancesearch1/vehicle-smart']);
              this.router.navigate(['advancesearch/', this.SearchValue, this.storeservice.breadCrumb.l1_actual_name, this.storeservice.breadCrumb.l2_actual_name, this.level3selected, this.storeservice.breadCrumb?.l3_actual_name, val.vc_number]);
            }

            // this.router.navigate(['advancesearch1', 'vehicle-smart']);
            this.isBrtLinkVisible = true
            // this.selectedFilters = this.level3data.filter((item: any) => item.ppl_actual_name == this.breadCrumb?.l3_actual_name)
            // this.getFeature()
            // this.calculateEmi()
          }
          else {
            document.getElementById('btnClose1').click();
          }
        }, error: (error: any) => {
          this.displayModal = false;
          document.getElementById('btnClose1').click();
        }
      })
    }
  }
  onSearchClick(level1: any, level2: any, level3: any) {

    if (isPlatformBrowser(this.platformId)) {
      this.clearLocalStorageData();
      if (level3 != '' && level3 != undefined && level3 != null)
        localStorage.setItem('pageLevel', '3');

      if (!localStorage.getItem('l1SearchData') || level1 != '') {
        this.selectedLevel2ID = null;
        this.selectedLevel3ID = null;
        localStorage.removeItem('l2SearchData')
        this.l2Data = [];
        this.level3data = [];
        this.level2Data = [];
        localStorage.setItem('l1SearchData', level1);
        localStorage.setItem('pageLevel', '1');
      }

      if (
        localStorage.getItem('pageLevel') == '2' &&
        !localStorage.getItem('l2SearchData')
      ) {
        localStorage.removeItem('l3SearchData');
        this.selectedLevel3ID = null;
        localStorage.setItem('l2SearchData', JSON.stringify(level2));
      }
      if (localStorage.getItem('l2SearchData')) {
        localStorage.removeItem('l3SearchData');
        this.selectedLevel3ID = null;
        this.l2Data = JSON.parse(localStorage.getItem('l2SearchData'));
      }

      if (
        this.level2Data?.length > 1 &&
        localStorage.getItem('pageLevel') == '3' &&
        !localStorage.getItem('l3SearchData')
      ) {
        localStorage.setItem('l3SearchData', level3);
      }
      let data = {
        level1: localStorage.getItem('l1SearchData')
          ? localStorage.getItem('l1SearchData')
          : level1,
        level2: this.l2Data ? this.l2Data.l2_actual_name : level2.l2_actual_name,
        level3: localStorage.getItem('l3SearchData')
          ? localStorage.getItem('l3SearchData')
          : level3,
        search: this.userEnteredValue ? this.userEnteredValue : ''
      };


      this.sub.add(
        this.ApiService.advanceSearch(data).subscribe({
          next: (res: any) => {
            if (res.success) {
              this.searchDataList = res?.data;
              let tempBreadCrumb = {
                l1_actual_name: '',
                l2_actual_name: '',
                l3_actual_name: '',
                l4_actual_name: '',
                filterCount: 0
              }
              if (level1 != '') {
                tempBreadCrumb.l1_actual_name = res?.data.l1_actual_name
                // this.breadCrumb = tempBreadCrumb;
                // document.getElementById('searchBtn').click();
              }
              if (localStorage.getItem('pageLevel') == '1') {
                let data = res?.data?.data

                this.listingData = data
                this.router.navigate(['advancesearch1', 'vehicle-map']);
                // setTimeout(() => {
                //   this.listingData = data
                //   // if (this.listingData?.length <= 3) {
                //     // this.listingData = this.listingData.concat(this.listingData)
                //   // }
                // }, 500);


              }
              if (localStorage.getItem('pageLevel') == '3') {
                tempBreadCrumb.l1_actual_name = res?.data.l1_actual_name
                tempBreadCrumb.l2_actual_name = res?.data.l2_actual_name
                this.level3data = res?.data?.data ? res?.data?.data : [];


              }
              if (localStorage.getItem('pageLevel') == '2') {
                tempBreadCrumb.l1_actual_name = res?.data?.l1_actual_name
                tempBreadCrumb.l2_actual_name = res?.data?.l2_actual_name
                this.level2Data = this.searchDataList?.data
                this.templevel2data = this.level2Data
                if (this.level2Data?.length == 1) {
                  this.onclickLevel2(0, 'level2')
                  this.onSearchClick('', '', this.level2Data[0]?.l3_actual_name)
                }

              }

              this.breadCrumb = tempBreadCrumb;

            }
          },
          error: (error: any) => { },
          complete: () => {

          },
        })
      );
    }
  }
  getChildValue(event) {
    if (isPlatformBrowser(this.platformId)) {
      if (event == "search1") {
        localStorage.removeItem('l1SearchData')
        localStorage.removeItem('l2SearchData')
        localStorage.removeItem('l3SearchData')
        this.storeservice.breadCrumb.l4_actual_name = ''
        this.storeservice.breadCrumb.l1_actual_name = '';
        this.storeservice.breadCrumb.l2_actual_name = '';
        this.storeservice.breadCrumb.l3_actual_name = '';
        this.selectedLevel2ID = '';
        this.selectedLevel3ID = '';
      }
      else if (event == "search2") {
        this.storeservice.isclick.next(false)
        localStorage.removeItem('l2SearchData');
        localStorage.removeItem('l3SearchData');
        this.selectedLevel2ID = '';
        this.selectedLevel3ID = '';
        this.storeservice.breadCrumb.l2_actual_name = '';
        this.storeservice.breadCrumb.l3_actual_name = ''
        this.storeservice.breadCrumb.l4_actual_name = ''
        this.behaviourservice.SearchConsoleFilterCount?.next(0);
      }
      else if (event == "search3") {
        this.storeservice.isclick.next(false)
        this.storeservice.breadCrumb.l3_actual_name = '';
        this.storeservice.breadCrumb.l4_actual_name = ''

        this.behaviourservice.SearchConsoleFilterCount?.next(0);
        localStorage.removeItem('l3SearchData');

      }
    }
  }
}
